var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Def',[_c('v-main',{staticClass:"text-h2 mt-16",attrs:{"align":"center"}},[_vm._v("Страница поиска на стадии разработки")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }